export default __webpack_public_path__ + "static/media/4b-I-pattern.50815cbc.jpg";